import React, { ReactNode } from 'react';
import { ActionCreator } from 'redux';
import { connect } from 'react-redux';

import { actions } from '../../../state/filterActions';
import { fetchResults } from '../../../state/resultActions';

import { Facet, OverrideValues, PaleState } from '../../../interfaces';
import { CheckboxDispatchProps, CheckboxFilter, CheckboxStateProps } from './CheckboxFilter';
import { ImageRating } from '../../resultList/images/ImageRating';

export const ratingValues = [{ value: '5' }, { value: '4' }, { value: '3' }, { value: '2' }, { value: '1' }] as Facet[];

export const displayValues: Record<string, ReactNode> = {
    1: <ImageRating id="HotelRatingFilter-1" rating={1} />,
    2: <ImageRating id="HotelRatingFilter-2" rating={2} />,
    3: <ImageRating id="HotelRatingFilter-3" rating={3} />,
    4: <ImageRating id="HotelRatingFilter-4" rating={4} />,
    5: <ImageRating id="HotelRatingFilter-5" rating={5} />,
};

export const mapStateToProps = (state: PaleState): CheckboxStateProps => ({
    id: 'HotelRatingFilter',
    label: 'Hotellstandard',
    facetList: ratingValues,
    displayValues: displayValues,
    checkboxValues: state.filters.rating,
    hideLabel: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterCheckboxRating,
    fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
